import { SuperAdminService } from "services/superAdminService";

class ReturnsSuperAdminService extends SuperAdminService<any> {
  constructor() {
    super(`returns`);
  }
}

export default new ReturnsSuperAdminService();
